import { Navigate, useLocation, useOutletContext } from "react-router";
import { FeedbackExternalContext } from "./context";

function FeedbackExternalPage() {
  const location = useLocation();
  const feedbackContext = useOutletContext<FeedbackExternalContext>();

  const { token, feedbackId } = feedbackContext;

  if (token && feedbackId) {
    return <Navigate to={{ pathname: "submit", search: location.search }} replace />;
  }

  return <div>{JSON.stringify(feedbackContext, null, 2)}</div>;
}

export default FeedbackExternalPage;
